import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import DatePicker from '../../Common/DatePicker';

/**
 * Presentational component for stories search for
 * Include query field and datepickers for searcing by publish date
 */
export default class StoriesForm extends PureComponent {
    static propTypes = {
        /**
         * Query term
         */
        query: PropTypes.string,
        /**
         * Publish minimum date
         */
        from: PropTypes.string,
        /**
         * Publish maximum date
         */
        to: PropTypes.string,
        /**
         * Action for handling submit event
         */
        onSubmit: PropTypes.func.isRequired,
    }

    static defaultProps = {
        query: '',
        from: null,
        to: null,
    }

    state = {
        query: this.props.query,
        from: this.props.from,
        to: this.props.to,
    }

    /**
     * Save new props related to query parameters to state
     * @param nextProps
     */
    componentWillReceiveProps(nextProps) {
        const nextState = ['query', 'from', 'to'].reduce((state, key) => {
            const value = nextProps[key];
            if (value !== this.props[key] && value !== this.state[key]) {
                return Object.assign({ [key]: value }, state);
            }
            return state;
        }, {});
        this.setState(nextState);
    }

    /**
     * Invoke submit action on form submit
     * @param ev
     */
    handleSubmit = (ev) => {
        ev.preventDefault();
        this.props.onSubmit(this.state);
    }
    /**
     * Change state when query string changed
     * @param ev
     */
    handleQueryChange = ev => this.setState({ query: ev.target.value })
    /**
     * Change state when min date changed
     * @param from
     */
    handleFromChange = from => this.setState({ from })
    /**
     * Change state when max date changed
     * @param to
     */
    handleToChange = to => this.setState({ to })

    render() {
        const { query, from, to } = this.state;
        return (
            <form
                className="search-form"
                onSubmit={this.handleSubmit}
            >
                <input
                    id="search_page_search_form"
                    className="search-input ui-input"
                    placeholder="Search"
                    autoComplete="off"
                    value={query}
                    onChange={this.handleQueryChange}
                />
                <DatePicker
                    label="From"
                    date={from}
                    maxDate={to || new Date().toJSON()}
                    onChange={this.handleFromChange}
                />
                <DatePicker
                    label="To"
                    date={to}
                    minDate={from}
                    maxDate={new Date().toJSON()}
                    onChange={this.handleToChange}
                />
                <div className="search-search">
                    <button
                        className="search-button ui-btn ui-btn_primary"
                        type="submit"
                    >
                        Search
                    </button>
                </div>
            </form>
        );
    }
}



// WEBPACK FOOTER //
// ./src/js/Stories/components/StoriesForm.jsx